/**
 * @constant
 */
const PreferencesTypes = {
    NOTIFICATION: "N",
    TAB: "T",
    FILTER_BOOKMARKS: 'FB'
};


module.exports = {
    PreferencesTypes
};
